<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'Clear'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 18px
  height 18px
  background-size 18px 18px
  background-repeat no-repeat
  background-position center
  background-image url('./images/clear.png')
}
</style>
